<template>
  <b-card>
    <template v-slot:header>
      <span class="breadcrumbs"><b-link :to="{name: `sequence`}">{{collection | capitalise | pluralise}}</b-link> / Create</span>
    </template>

    <b-form @submit.stop.prevent="create_item">
      <b-alert :show="current_period_usage === null || (current_period_usage && current_period_usage.left < 1)" variant='warning'>
        You can't add any more contacts. Please upgrade your plan<span v-if="current_period_usage"> or wait until it resets on {{current_period_usage.resets | date}}</span>.
      </b-alert>

      <b-form-group label="Email*" label-cols="3">
        <b-form-input v-model="item.email" type="email" required placeholder="name@example.com"></b-form-input>
      </b-form-group>

      <b-form-group label="First name*" label-cols="3">
        <b-form-input v-model="item.first_name" required placeholder="John"></b-form-input>
      </b-form-group>

      <b-form-group label="Last name" label-cols="3">
        <b-form-input v-model="item.last_name" placeholder="Smith"></b-form-input>
      </b-form-group>

      <b-form-group label="Organisation" label-cols="3">
        <b-form-input v-model="item.organisation" placeholder="Company Ltd"></b-form-input>
      </b-form-group>

      <b-form-group label="Website URL" label-cols="3">
        <b-form-input v-model="item.website" type='url' placeholder="https://example.com"></b-form-input>
      </b-form-group>

      <b-form-group label="Custom 1" label-cols="3">
        <b-form-input v-model="item.custom_1"></b-form-input>
      </b-form-group>

      <b-form-group label="Custom 2" label-cols="3">
        <b-form-input v-model="item.custom_2"></b-form-input>
      </b-form-group>

      <b-form-group label="Custom 3" label-cols="3">
        <b-form-input v-model="item.custom_3"></b-form-input>
      </b-form-group>

      <b-form-group label="Custom 4" label-cols="3">
        <b-form-input v-model="item.custom_4"></b-form-input>
      </b-form-group>

      <b-form-group label="Timzone offsets (hours)" label-cols="3">
        <b-form-input v-model="item.timezone_offset"></b-form-input>
      </b-form-group>

      <LoadingButton type="submit" variant='primary' :loading="is_saving" v-if='current_period_usage && current_period_usage.left >= 1'>Save</LoadingButton>
    </b-form>

  </b-card>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import { db } from '@/main.js'

export default {
  metaInfo: {title: 'Recipient create'},
  mixins: [ItemMixin],
  props: ['profile'],
  validations: {
    item: {

    }
  },
  firestore: function () {
    return {
      _item: db.collection('sequence').doc(this.$route.params.id).collection(this.collection).doc()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'recipient') {
      next()
      return
    }

    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  computed: {
    current_period_usage() {
      if (!this.profile.team.current_period) {
        return null
      } else if (this.profile.team.current_period.id) {
        let used = 0
        if (this.profile.team.current_period.usage[this.profile.id]) {
          used = this.profile.team.current_period.usage[this.profile.id].recipients || 0
        }
        let total = this.profile.team.current_period.max_usage_in_period_per_user
        let left = total - used
        let resets = this.profile.team.current_period.current_period_end

        return {used: used, total: total, left: left, resets: resets}
      }

      return undefined
    }
  },
  data() {
    return {
      param: 'recipient',
      collection: 'recipient',
      item: {
        completed_steps: [],
        items: [],
        next_step: null,
        next_step_date: null,
        task_status: 'pending',
        status: 'pending',// TODO this.constants.lead_status.not_started,
        timezone_offset: this.profile.default_timezone_offset || 0,
        email: '',
        first_name: '',
        last_name: '',
        organisation: '',
        website: '',
        custom_1: '',
        custom_2: '',
        custom_3: '',
        custom_4: '',
      },
    }
  },
}
</script>

<style>

</style>
